// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o8Oe2Mt6hEi0UE {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.omVt7LfjpoqGRW {
  margin-top: 8px;
  color: var(--ds-text-danger, #ae2e24);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `o8Oe2Mt6hEi0UE`,
	"error": `omVt7LfjpoqGRW`
};
export default ___CSS_LOADER_EXPORT___;
